// extracted by css-extract-rspack-plugin
export default {"wrapper":"_7955f7f8","tooltipWrapper":"_d9baa6ad","bubble":"_afe55d5","withBorder":"_a3731265","icon":"_a39efa20","printLink":"_f6f330ba"};